import { SET_USER } from "./actionTypes";
import { IClientUserProfile } from "constants/interfaces";
import { STORE } from "appredux";

export const raSET_USER = (payload?:IClientUserProfile) => STORE.dispatch({
    type: SET_USER,
    payload:payload?payload:{}
  });